import React from "react";
import Chart from "react-apexcharts";
import { Card, CardContent, Typography, Box, Grid } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';

const YearlyExpensesChart = ({ expensesData, year }) => {
  const theme = useTheme();
  const monthNames = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth() + 1;

  const displayData = expensesData.filter(s => 
    parseInt(year) < currentYear || s.month <= currentMonth
  );

  const chartOptions = {
    chart: {
      type: "bar",
      toolbar: { show: false },
      foreColor: theme.palette.text.secondary,
    },
    xaxis: {
      categories: displayData.map(s => monthNames[s.month - 1]),
    },
    yaxis: {
      labels: {
        formatter: (val) => `₹${(val / 1000).toFixed(0)}k`,
      },
    },
    dataLabels: {
      enabled: false,
    },
    colors: [theme.palette.error.main],
    grid: {
      borderColor: theme.palette.divider,
    },
    tooltip: {
      theme: theme.palette.mode,
      y: {
        formatter: (val) => `₹ ${val.toLocaleString('en-IN')}`,
      },
    },
  };

  const chartSeries = [
    {
      name: "Expenses",
      data: displayData.map((s) => s.totalExpenses),
    },
  ];

  return (
    <Card>
      <CardContent>

        {/* BAR CHART */}
        <Box sx={{ mt: 3 }}>
          <Chart
            options={chartOptions}
            series={chartSeries}
            type="bar"
            height={350}
          />
        </Box>

        {/* MONTH COMPARISON */}
        <Grid container spacing={2} sx={{ mt: 3 }}>
          {displayData.map((m, i) => (
            <Grid item xs={6} md={3} key={i}>
              <Box
                sx={{
                  p: 2,
                  borderRadius: '12px',
                  backgroundColor: m.difference >= 0 ? theme.palette.success.light : theme.palette.error.light,
                  color: m.difference >= 0 ? theme.palette.success.dark : theme.palette.error.dark,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  textAlign: 'center'
                }}
              >
                <Typography variant="subtitle2" fontWeight="600">
                  {monthNames[m.month - 1]}
                </Typography>
                <Typography variant="h6" fontWeight="bold" sx={{ my: 1 }}>
                  ₹{m.totalExpenses.toLocaleString('en-IN')}
                </Typography>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', my: 0.5, gap: 0.5 }}>
                  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <Typography variant="caption" sx={{ opacity: 0.8 }}>Difference from previous month</Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      {m.difference >= 0 ? <ArrowUpwardIcon fontSize="small" /> : <ArrowDownwardIcon fontSize="small" />}
                      <Typography variant="subtitle2" fontWeight="600">
                        ₹{Math.abs(m.difference).toLocaleString('en-IN')}
                      </Typography>
                    </Box>
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Typography variant="caption" sx={{ mr: 0.5, opacity: 0.8 }}>Change:</Typography>
                    <Typography variant="caption" sx={{ opacity: 0.8 }}>
                      {m.percentageChange !== undefined ? m.percentageChange.toFixed(2) : '0.00'}%
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>

      </CardContent>
    </Card>
  );
};

export default YearlyExpensesChart;
